// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, "[data-v-995745f4] .v-list-item__mask{background:#ffe8b1!important;color:#000!important}", ""]);
// Exports
module.exports = exports;
